import { useTranslation } from 'react-i18next';
import { useLogout } from '@/features/auth-logout';
import { isTableDensity, useTableDensity } from '@/shared/lib';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
  IconSettings,
} from '@/shared/ui';

export interface ProfileMenuProps {
  onChangePassword: () => void;
}

/**
 * Меню профиля внизу сайдбара (ТЗ ACC 4.7.1: «Сменить пароль» и «Выйти»; README §1 — вместо
 * меню роли прототипа). Плотность реестров — пользовательская настройка (README «Настраиваемые
 * параметры»), см. docs/decisions.md.
 */
export function ProfileMenu({ onChangePassword }: ProfileMenuProps) {
  const { t } = useTranslation('shell');
  const { logout, pending } = useLogout();
  const density = useTableDensity((state) => state.density);
  const setDensity = useTableDensity((state) => state.setDensity);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={t('profile.menuLabel')}
        className="flex size-32 shrink-0 cursor-pointer items-center justify-center rounded-16 text-ink-700 transition-colors duration-(--duration-fast) hover:bg-sidebar-hover data-[state=open]:bg-sidebar-hover"
      >
        <IconSettings size={18} />
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" align="end" sideOffset={20} className="w-216">
        <DropdownMenuLabel>{t('profile.density')}</DropdownMenuLabel>
        <DropdownMenuRadioGroup
          value={density}
          onValueChange={(value) => {
            if (isTableDensity(value)) setDensity(value);
          }}
        >
          <DropdownMenuRadioItem value="comfortable">
            {t('profile.densityComfortable')}
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="compact">
            {t('profile.densityCompact')}
          </DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
        <DropdownMenuItem onSelect={onChangePassword}>
          {t('profile.changePassword')}
        </DropdownMenuItem>
        <DropdownMenuItem
          disabled={pending}
          onSelect={() => {
            void logout();
          }}
        >
          {t('profile.logout')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
